<template>
  <div class="section-title">
    <div>
      <div v-if="eyebrow" class="section-title__eyebrow">{{ eyebrow }}</div>
      <h2>{{ title }}</h2>
      <p v-if="subtitle">{{ subtitle }}</p>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'SectionTitle',
  props: {
    eyebrow: String,
    title: {
      type: String,
      required: true,
    },
    subtitle: String,
  },
};
</script>

<style scoped src="./SectionTitle.css"></style>
